import PropTypes from "prop-types";
import { useMemo } from "react";
// @mui
import { CssBaseline } from "@mui/material";
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider as MUIThemeProvider,
} from "@mui/material/styles";
// components
import { useSettingsContext } from "../components/settings";
//
import palette from "./palette";
import typography from "./typography";
import shadows from "./shadows";
import customShadows from "./customShadows";
import componentsOverride from "./overrides";
import GlobalStyles from "./globalStyles";
import { useLocation } from "react-router";

// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default function ThemeProvider({ children }) {
  const { themeMode, themeDirection } = useSettingsContext();
  const location = useLocation();

  const isHotelRoute =
    location.pathname.startsWith("/hotel") ||
    location.pathname.startsWith("/shop") ||
    location.pathname.startsWith("/voucher-admin");

  const effectiveThemeMode = isHotelRoute ? "light" : themeMode;


  const themeOptions = useMemo(
    () => ({
      palette: palette(effectiveThemeMode),
      typography,
      shape: { borderRadius: 8 },
      direction: themeDirection,
      shadows: shadows(effectiveThemeMode),
      customShadows: customShadows(effectiveThemeMode),
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          mediumSmall: 768,
          md: 900,
          mediumLarge: 1024,
          lg: 1200,
          largeExtraLarge: 1350,
          xl: 1536,
        },
      },
    }),
    [themeDirection, themeMode, location.pathname]
  );

  const theme = createTheme(themeOptions);

  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
